import { ITranslationEditItem } from './ITranslationEditItem';

export interface ISurveyPrivacyPolicyEditModel {
	surveyPrivacyPolicyId?: number;
	title: ITranslationEditItem;
	content: ITranslationEditItem;
	checkboxText: ITranslationEditItem;
	useClientPrivacyPolicy: boolean;
	clientPrivacyPolicyId?: number;
	isActive: boolean;
}

export enum PrivacyPolicyEditFieldType {
	PRIVACYPOLICY_TITLE = 'PRIVACYPOLICY_TITLE',
	PRIVACYPOLICY_CONTENT = 'PRIVACYPOLICY_CONTENT',
	PRIVACYPOLICY_CHECKBOX = 'PRIVACYPOLICY_CHECKBOX',
}

export interface IPrivacyPolicyEditFieldChangeModel {
	privacyPolicyEditFieldType: PrivacyPolicyEditFieldType;
	privacyPolicyEditValue: string;
}

export interface IPrivacyPolicyTranslationUpdateModel {
	privacyPolicyEditFieldType: PrivacyPolicyEditFieldType;
	translationEditItem: ITranslationEditItem;
}
